import type { WClientTestimonialsCardsTranslations } from "./pl";

export const en: WClientTestimonialsCardsTranslations = {
  defaultTitle: "What our clients say",
  prev: "Previous",
  next: "Next",
  goToSlide: "Go to testimonial",
};
